import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { ICartTrack } from '../../../../Interface/track'
import { AppType } from '../../../../types/app.type'

@Component({
  selector: 'bmcore-track-in-cart-popup',
  templateUrl: './bmcore-track-in-cart-popup.component.html',
  styleUrls: ['./bmcore-track-in-cart-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreTrackInCartPopupComponent {
  @Input() track: ICartTrack
  @Input() appType: AppType

  @Output() closeCartPopupEvent2 = new EventEmitter()

  constructor() {}

  closeCartPopupEvent() {
    this.closeCartPopupEvent2.emit()
  }
}
